exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-address-confirmation__title[data-v-537a572c] {\n  margin: 0;\n  color: #111;\n  text-align: center;\n  font-size: 2rem;\n  font-weight: 600;\n}\n.modal-address-confirmation__actions[data-v-537a572c] {\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-column-gap: 5%;\n     -moz-column-gap: 5%;\n          column-gap: 5%;\n  padding: 0 8px;\n}\n", ""]);

// exports
